(function () {
  'use strict';

  var SKIP_TAGS = {
    SCRIPT: 1,
    STYLE: 1,
    PRE: 1,
    CODE: 1,
    TEXTAREA: 1,
    INPUT: 1,
    NOSCRIPT: 1,
  };
  var PATTERN = /~~([^~]+)~~/g;

  function shouldSkip(node) {
    var parent = node.parentNode;
    while (parent && parent.nodeType === 1) {
      if (SKIP_TAGS[parent.nodeName]) return true;
      parent = parent.parentNode;
    }
    return false;
  }

  function processTextNode(textNode) {
    var text = textNode.nodeValue;
    if (!text || text.indexOf('~~') === -1) return;
    if (shouldSkip(textNode)) return;

    PATTERN.lastIndex = 0;
    if (!PATTERN.test(text)) return;

    var fragment = document.createDocumentFragment();
    var lastIndex = 0;
    PATTERN.lastIndex = 0;
    var match;
    while ((match = PATTERN.exec(text)) !== null) {
      if (match.index > lastIndex) {
        fragment.appendChild(
          document.createTextNode(text.substring(lastIndex, match.index))
        );
      }
      var s = document.createElement('s');
      s.textContent = match[1];
      fragment.appendChild(s);
      lastIndex = match.index + match[0].length;
    }
    if (lastIndex < text.length) {
      fragment.appendChild(document.createTextNode(text.substring(lastIndex)));
    }

    if (textNode.parentNode) {
      textNode.parentNode.replaceChild(fragment, textNode);
    }
  }

  function processRoot(root) {
    if (!root || !root.nodeType) return;
    if (root.nodeType === 3) {
      processTextNode(root);
      return;
    }
    if (root.nodeType !== 1 && root.nodeType !== 11) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (node.nodeValue.indexOf('~~') === -1) return NodeFilter.FILTER_SKIP;
        if (shouldSkip(node)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i = 0; i < nodes.length; i++) processTextNode(nodes[i]);
  }

  function init() {
    processRoot(document.body);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList') {
          for (var j = 0; j < m.addedNodes.length; j++) {
            processRoot(m.addedNodes[j]);
          }
        } else if (m.type === 'characterData') {
          processTextNode(m.target);
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
